var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92985 6.22129L0 4.77539V12.3473L7.49584 16.1143L7.19144 8.35208L4.14744 6.81106V8.54233C4.14744 9.15113 3.70987 9.22089 3.55767 9.20821C3.1201 9.17174 2.92985 8.89747 2.92985 8.54233V6.22129Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10463 0L0.513672 3.59572L3.38644 5.04162L10.8442 1.33175L8.10463 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02917 7.30553L4.79492 5.74548L12.1386 1.99756L15.4679 3.61468L8.02917 7.30553Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61914 15.981V8.40903L16.0008 4.64209V11.2438L8.61914 15.981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.dccbc87bb20bf7b70666b1d5c06df5a3.svg";
export { ForwardRef as ReactComponent };